// Inspire Hardware trade-program conversion bridge.
// Fires only after Clay confirms a successful application and Shopify permits marketing tracking.
(function initializeLinkedInTradeApplicationTracking() {
  'use strict';

  const PARTNER_ID = '9883724';
  const CONVERSION_ID = '28035436';
  const EVENT_NAME = 'clay:form:submitted';
  const DEDUPE_KEY = 'inspire_linkedin_trade_application_sent';

  function marketingAllowed() {
    try {
      return window.Shopify?.customerPrivacy?.marketingAllowed() === true;
    } catch (_error) {
      return false;
    }
  }

  function sendConversion() {
    if (!marketingAllowed()) return;

    try {
      if (window.sessionStorage.getItem(DEDUPE_KEY) === '1') return;
      window.sessionStorage.setItem(DEDUPE_KEY, '1');
    } catch (_error) {
      // Continue if browser storage is unavailable; Clay emits once per accepted submission.
    }

    const image = new Image(1, 1);
    image.alt = '';
    image.src = `https://px.ads.linkedin.com/collect/?pid=${encodeURIComponent(PARTNER_ID)}&conversionId=${encodeURIComponent(CONVERSION_ID)}&fmt=img`;
  }

  document.addEventListener(EVENT_NAME, sendConversion, { passive: true });
})();
